import DATEFORMAT from 'dateformat';
import {getName as countries_ISO3166_getName} from 'i18n-iso-countries'

interface CountryCode {
    [key: string]: string;
}

export function getDomain(value: string): string | null {

    var regExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)(?:.*)?$/g;
    var match = regExp.exec(value.trim());
    if (match !== null) {
        return match[1];
    }
    return null;
}

export function _printDate(sqlDate: Date): string {
    if (undefined == sqlDate) return 'undefined';
    if (null == sqlDate) return 'null';
    return DATEFORMAT(sqlDate, "mmmm, yyyy")   // August, 1945
//    return DATEFORMAT(sqlDate, "mediumDate")   // Aug 6, 1945
 //   return DATEFORMAT(sqlDate, "longDate")       // August 6, 1945
}
export function _printShortDate(sqlDate: Date): string {
    if (undefined == sqlDate) return 'undefined';
    if (null == sqlDate) return 'null';
    return DATEFORMAT(sqlDate, "mmm, yyyy")   // Aug, 1945
}
export function _printShortFullDate(sqlDate: Date): string {
    if (undefined == sqlDate) return 'undefined';
    if (null == sqlDate) return 'null';
    return DATEFORMAT(sqlDate, "mediumDate")   // Aug 6, 1945
}
export function _printSmallestFullDate(sqlDate: string): string {
    if (undefined == sqlDate) return 'undefined';
    if (null == sqlDate) return 'null';
    return DATEFORMAT(sqlDate, 'mmm dd, yy')   // Aug 6, 1945
}

export function _printMediumDate(sqlDate: string): string {
    if (undefined == sqlDate) return 'undefined';
    if (null == sqlDate) return 'null';
    return DATEFORMAT(sqlDate, "mediumDate")       // August 6, 1945
}

export function _printNumber(number: number | undefined): string | undefined {
    if (undefined == number) return number;
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function _printDomainRank(number: number | undefined, hidden?: boolean): string | undefined {

    if (undefined == number) return number;

    // 2 bill is a const that means that Domain has no ranking ... meaning is ranked super low
    if (number == 2000000000) {
        return 'low rank';
    }

    const rankString = _printNumber(number);

    if (!hidden) {
        return rankString;
    }
    else {
        return rankString!.replace(/[0-9]/g, "*");
    }	
}

export function _countryNameFromCode(country: string): string {

    const COUNTRY_NAME: CountryCode = {
        'AF': 'Afghanistan',
        'AX': 'Åland Islands',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AS': 'American Samoa',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AG': 'Antiguaand Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AW': 'Aruba',
        'AU': 'Australia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BJ': 'Benin',
        'BM': 'Bermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia',
        'BQ': 'Bonaire, Sint Eustatiusand Saba',
        'BA': 'Bosnia and Herzegovina',
        'BW': 'Botswana',
        'BR': 'Brazil',
        'AQ': 'British Antarctic Territory',
        'IO': 'British Indian Ocean Territory',
        'VG': 'British Virgin Islands',
        'BN': 'Brunei',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'CV': 'Cape Verde',
        'KY': 'Cayman Islands',
        'CF': 'Central African Republic',
        'TD': 'Chad',
        'CL': 'Chile',
        'CN': 'China',
        'CX': 'Christmas Island',
        'CC': 'Cocos(Keeling) Island',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CG': 'Congo(Brazzaville)',
        'CD': 'Congo, Democratic Republic',
        'CK': 'Cook Islands',
        'CR': 'Costa Rica',
        'CI': 'Côte d\'Ivoire (Ivory Coast)',
        'HR': 'Croatia',
        'CU': 'Cuba',
        'CW': 'Curaçao',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'TL': 'East Timor',
        'EC': 'Ecuador',
        'SV': 'El Salvador',
        'EG': 'Egypt',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'SZ': 'Eswatini',
        'ET': 'Ethiopia',
        'FK': 'Falkland Islands',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'FR': 'France',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern and Antarctic Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'DE': 'Germany',
        'GH': 'Ghana',
        'GI': 'Gibraltar',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GG': 'Guernsey',
        'GN': 'Guinea',
        'GW': 'Guinea Bissau',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HM': 'Heard and McDonald Islands',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'ID': 'Indonesia',
        'IR': 'Iran',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IM': 'Isle of Man',
        'IL': 'Israel',
        'IT': 'Italy',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JE': 'Jersey',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KP': 'Korea, North',
        'KR': 'Korea, South',
        'XK': 'Kosovo',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': 'Laos',
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MO': 'Macau',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'MQ': 'Martinique',
        'YT': 'Mayotte',
        'MX': 'Mexico',
        'FM': 'Micronesia',
        'MD': 'Moldova',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'NU': 'Niue',
        'NF': 'Norfolk Island',
        'MK': 'North Macedonia',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestine',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn Islands',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Réunion',
        'RO': 'Romania',
        'RW': 'Rwanda',
        'RU': 'Russia',
        'BL': 'Saint Barthélemy',
        'SH': 'Saint Helena, Ascensionand Tristan da Cunha',
        'KN': 'Saint Kitts and Nevis',
        'LC': 'Saint Lucia',
        'MF': 'Saint Martin',
        'PM': 'Saint Pierreand Miquelon',
        'VC': 'Saint Vincent and the Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome and Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SL': 'Sierra Leone',
        'SX': 'Sint Maarten',
        'SG': 'Singapore',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'SS': 'South Sudan',
        'GS': 'South Georgia and the South Sandwich Islands',
        'ES': 'Spain',
        'LK': 'Sri Lanka',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SJ': 'Svalbardand Jan Mayen',
        'SY': 'Syria',
        'TW': 'Taiwan',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania',
        'TH': 'Thailand',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad and Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TC': 'Turks and Caicos Islands',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
                
        'UK': 'United Kingdom',
                
        'US': 'United States',
        'UM': 'United States Minor Outlying Islands',
        'UY': 'Uruguay',
        'VI': 'U.S.Virgin Islands',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VA': 'Vatican',
        'VE': 'Venezuela',
        'VN': 'Vietnam',
        'WF': 'Wallis and Futuna',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe',
        'EU': 'European Union'
    };

    const name = COUNTRY_NAME[country];
    if (undefined != name) return name;

    return country;

}

export function _printPercent(number: number | undefined): string | number | undefined {
	if (undefined == number) return number;
    let percentage = 100 * number;
    return (percentage < 0.1) ? 'less than 0.1' : percentage.toFixed(2);
}

export function _extractWebsiteFromURL(url: string | undefined): string | undefined {
    if (undefined == url) return url;
    if (url.length == 0) return url;
    let matchedWebsite = url.match(/https?:\/\/([^\/]+).*/);
    if (null != matchedWebsite) return matchedWebsite[1];
    return url;
}

export function _isGoogleIcon(path: string): boolean {
	return path.startsWith('google:');
}

export function _getGoogleIcon(path: string): string {
	return path.substr('google:'.length);;
}

export function _getISO3166ContryName(coutryCode: string): string {
    const countryISO3166 = countries_ISO3166_getName(coutryCode, 'en');
    if (undefined != countryISO3166) return countryISO3166;

    return coutryCode; // return the original code if we could not translate the coutry
}

export function _getGoogleChartCompliantCoutryName(coutryCode: string): string {

    // those countries in google's geocharts are not defined according to standard ISO-3166-1
    const COUNTRY_OVERRIDE: CountryCode = {
        'TP': 'East Timor',
        'YU': 'Yugoslavia',
        'CD': 'Congo - Binshasa',
        'FK': 'Falkland Islands',
        'CG': 'Congo - Brazzaville',
        'AX': 'Aland Islands',
        'MD': 'Moldova',
        'PS': 'Palestinian Territory',
        'ZR': 'Zaire',
        'SZ': 'Swaziland',
        'AN': 'Netherlands Antilles',
        'QO': 'Outlying Oceania',
        'BN': 'Brunei',
        'IR': 'Iran',
        'MK': 'Macedonia',
        'SY': 'Syria',
        'YD': 'People\'s Democratic Republic of Yemen',
        'BU': 'Burma',
        'FX': 'Metropolitan France',
        'NT': 'Neutral Zone',
        'US': 'United States',
        'CI': 'Ivory Coast',
        'VA': 'Vatican',
        'LA': 'Laos',
        'VG': 'British Virgin Islands',
        'TZ': 'Tanzania',
        'RU': 'Russia',
        'VI': 'U.S. Virgin Islands',
        'CC': 'Cocos Islands'
        };

    const override = COUNTRY_OVERRIDE[coutryCode];
    if (undefined != override) return override;

    return _getISO3166ContryName(coutryCode);
}

export function _getCoutryGoogleChartName(countryCode: string | undefined): string | undefined {
    if (undefined == countryCode) return countryCode;
    return _getGoogleChartCompliantCoutryName(countryCode);
};

export function isForbiddenDomainName(domain: string): boolean {

    var regExp1 = /^.*\.(?:gov|mil)$/g;
    var regExp2 = /^.*\.(?:gov|mil).\w\w$/g;
    var match = regExp1.exec(domain.trim());
    if (match !== null) {
        return true;
    }
    match = regExp2.exec(domain.trim());
    if (match !== null) {
        return true;
    }
    return false;
}

export function _extractSocialMediaSlug(url: string): string {

    const parts = url.split('/');
    if (parts.length < 2) {
        return url;
    }
    
    const last = parts.pop();
    if (last!.length > 0) {
        return last!;
    }
    else {
        return parts.pop()!;
    }
}
